import React from 'react';
import Template from './template';
import { ServiceInterviewNoAnswer } from 'components';
import { useServiceStatus } from 'hooks';
import moment from 'moment';

function ServiceInterviewNoAnswerView(): React.ReactElement {
    const { serviceState } = useServiceStatus();
    const { serviceStatusHistoryList } = serviceState;
    const inactiveDueDate: string | undefined = serviceStatusHistoryList.find((item) => item.serviceDocStatus === 'interview_notice')?.createDate;

    return (
        <Template>
            <ServiceInterviewNoAnswer
                inactiveDueDate={
                    inactiveDueDate
                        ? moment(inactiveDueDate)
                              .add(30, 'days')
                              .format('YYYY년 MM월 DD일')
                        : '-'
                }
            />
        </Template>
    );
}

export default ServiceInterviewNoAnswerView;
